import React, { useEffect, useState } from 'react'; // eslint-disable-line
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { reduce, indexOf, map, difference, debounce } from 'lodash';
import { getTablePreference } from '../../modules/App/AppReducer';
import { fetchColumnsData, dispatchColumnData } from './actions';
import Pusher from '../pusher';

const RESOURCE_TYPE = {
  OPPORTUNITY: 'OPPORTUNITY',
  ACCOUNT: 'ACCOUNT',
  USER: 'USER',
  PRODUCT: 'PRODUCT',
  COMPETITOR: 'COMPETITOR',
};

function ColumnDataManager(props) {
  const { resourceType } = props;
  const columns = useSelector((state) => {
    return getTablePreference(state, props.id);
  });

  const [socketIds, setSocketIds] = useState([]);
  const [checkedIds, setCheckedIds] = useState([]);
  const dispatch = useDispatch();

  function getColumnIds() {
    return reduce(columns, (items, column) => {
      const isSystem = column.is_system === true;
      const shouldLoad = !isSystem || (isSystem && indexOf(props.forceLoadSystemColumnTags, column.tag) >= 0)

      if (column.is_visible && shouldLoad) {
        items.push(column._id);
      }
      return items;
    }, []);
  }

  const getIDs = (data) => {
    let ids = [];
    if (resourceType === RESOURCE_TYPE.OPPORTUNITY) {
      ids = map(data, 'opportunity_id');
    } else if (resourceType === RESOURCE_TYPE.ACCOUNT) {
      ids = map(data, 'account_id');
    } else if (resourceType === RESOURCE_TYPE.USER) {
      ids = map(data, 'user_id');
    }
    return ids;
  };

  useEffect(() => {
    if (props.priorityData.length) {
      const newColumnIds = getColumnIds();
      if (newColumnIds.length > 0) {
        const needToLoadIds = getIDs(props.priorityData);
        props.onColumnLoading(newColumnIds);
        dispatch(fetchColumnsData(newColumnIds, needToLoadIds, resourceType))
          .then(
            (results) => {
              if (results.socketId) {
                setSocketIds([...socketIds, results.socketId]);
              } else {
                props.onColumnLoaded(newColumnIds);
              }
            }
          );
      }

    }
  }, [props.priorityData])

  useEffect(() => {
    const newColumnIds = getColumnIds();

    if (newColumnIds.length > 0) {
      let data = props.getRowData();
      let ids = getIDs(data);

      if (props.startIndex !== null && props.stopIndex !== null) {
        ids = ids.slice(props.startIndex, props.stopIndex);
      }
      
      const needToLoadIds = difference(ids, checkedIds);
      
      if (needToLoadIds.length > 0) {
        setCheckedIds([...checkedIds, ...needToLoadIds]);
        props.onColumnLoading(newColumnIds);
        dispatch(fetchColumnsData(newColumnIds, needToLoadIds, resourceType))
          .then(
            (results) => {
              if (results.socketId) {
                setSocketIds([...socketIds, results.socketId]);
              } else {
                props.onColumnLoaded(newColumnIds);
              }
            }
          );
      }
    }
  }, [columns, props.startIndex, props.stopIndex, props.searchId]);



  const onSocketCallback = (socketData) => {
    if (socketData?.success === true) {
      dispatch(dispatchColumnData(socketData.data));
      if (socketData?.done) {
        props.onColumnLoaded(getColumnIds());
      }
    }
  };


  if (socketIds?.length) {
    return map(socketIds, (socketId) => {
      return (<Pusher key={socketId} event={socketId} handler={onSocketCallback} />);
    });
  }
  return (<></>);
}


ColumnDataManager.propTypes = {
  resourceType: PropTypes.string,
  getRowData: PropTypes.func,
  onColumnLoading: PropTypes.func,
  onColumnLoaded: PropTypes.func,
  forceLoadSystemColumnTags: PropTypes.arrayOf(PropTypes.string),
  deferLoadIds: PropTypes.arrayOf(PropTypes.string),
  startIndex: PropTypes.number,
  stopIndex: PropTypes.number,
  searchId: PropTypes.string,
  priorityData: PropTypes.arrayOf(PropTypes.shape({})),
};
ColumnDataManager.defaultProps = {
  getRowData: () => [],
  resourceType: null,
  onColumnLoading: () => {},
  onColumnLoaded: () => {},
  forceLoadSystemColumnTags: [],
  deferLoadIds: null,
  startIndex: null, 
  stopIndex: null,
  searchId: '',
  priorityData: [],
};

ColumnDataManager.RESOURCE_TYPE = RESOURCE_TYPE;

export default ColumnDataManager;
